export const GETSITECONTENT = 'GETSITECONTENT';
